/** AccountPage — TODO: Port from prototype */
import React from 'react';

const AccountPage: React.FC = () => (
  <div>
    <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 8 }}>Account</h1>
    <p style={{ color: 'var(--color-text-muted)' }}>Coming soon — this page will be ported from the Family Meal Planner prototype.</p>
  </div>
);
export default AccountPage;
